"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const async_component_1 = require("./async-component");
exports.loadBranchDataObject = (chyk, matches, abortController) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const promisesConfig = matches
        .map(({ route, match }) => {
        return route.loadData
            ? {
                dataKey: route.dataKey,
                promise: route.loadData({ chyk, match, abortController }, chyk.deps),
            }
            : Promise.resolve(null);
    })
        .filter(Boolean);
    const results = yield Promise.all(promisesConfig.map(c => c.promise));
    const resultsObject = results.reduce((prev, current, index) => {
        prev[promisesConfig[index].dataKey] = current;
        return prev;
    }, {});
    return resultsObject;
});
function loadBranchComponents(matches) {
    return Promise.all(matches.map(match => {
        const component = match.route.component;
        if (async_component_1.isAsyncComponent(component)) {
            return component.load();
        }
        return component;
    }));
}
exports.loadBranchComponents = loadBranchComponents;
//# sourceMappingURL=match.js.map